import { render, staticRenderFns } from "./PendingCarts.vue?vue&type=template&id=3f482e7f"
import script from "./PendingCarts.vue?vue&type=script&lang=js"
export * from "./PendingCarts.vue?vue&type=script&lang=js"
import style0 from "./PendingCarts.vue?vue&type=style&index=0&id=3f482e7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports